<template>
  <el-table-column
    align="center"
    v-bind="$attrs"
    :label="getLabelText(base, idName)"
    show-overflow-tooltip
    >
    <template slot-scope="scope">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          placement="left"
          :content="getLabelText(base, idName)"
          >
          <span
            class="allow-click-copy"
            @click="doCopy(scope.row[idField])"
            >
            {{ scope.row[idField] }}
          </span>
        </el-tooltip>
      </div>
      <div
        v-if="scope.row[unhideIDField] && scope.row[idField] !== scope.row[unhideIDField]"
        >
        <el-tooltip
          class="item"
          effect="dark"
          placement="left"
          :content="getLabelText(base, unhideIDField)"
          >
          <span
            class="allow-click-copy gray"
            @click="doCopy(scope.row[unhideIDField])"
            >
            {{ scope.row[unhideIDField] }}
          </span>
        </el-tooltip>
      </div>
    </template>
  </el-table-column>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { getLabelText } from '@/utils/i18n'

export default {
  name: 'id-field',
  props: {
    base: {
      type: String,
      required: true
    },
    idName: {
      type: String,
      default: 'id'
    },
    idField: {
      type: String,
      default: 'id'
    },
    unhideIDField: {
      type: String,
      default: 'unhide_id'
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    doCopy,
    getLabelText
  }
}
</script>
